module.exports = __webpack_public_path__ + "static/media/16-speaker_profile.6c886595.webp";